import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const charactersToFontSizeMap = [
  { characters: 10, font: 30 },
  { characters: 13, font: 27 },
  { characters: 17, font: 22 },
  { characters: 20, font: 18 },
  { characters: 24, font: 14 },
];

export const getDynamicFontSize = (value, className) => {
  if (
    className &&
    className.includes('simple-text') &&
    typeof value === 'string' &&
    value
  ) {
    let font = 34;
    charactersToFontSizeMap.forEach((map) => {
      if (value.length > map.characters) {
        font = map.font;
      }
    });
    return { fontSize: `${font}px` };
  }
  return {};
};

export default function Value({ value, type, className, addPlusSign }) {
  return value ? (
    <div className="basic-pod-value-container">
      {type === 'currency' && <span className="basic-pod-value-currency">$</span>}
      <div
        style={getDynamicFontSize(value, className)}
        className={`basic-pod-value ${className ? className : ''}`}
      >
        {value}
      </div>
      {type === 'percent' && <span className="basic-pod-value-percent">%</span>}
      {addPlusSign && <span className="basic-pod-value-plus-sign">+</span>}
    </div>
  ) : null;
}

Value.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['currency', 'percent']),
  className: PropTypes.string,
};
